import React, { Component } from 'react';
import * as GServ from '../services/GatewayService';
import { CircularProgress } from '@material-ui/core';


export default class RegretPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSpinner: false,
            status: '',
            warning: '',
            mainHeadText: 'Offline Verification Required...',
        }
    }
    
    componentDidMount() {
        // console.log('sending flag log request...');
        this.sendLogRequest();
    }
    
    render() {
        return (
            <div>
                <h3>{this.state.mainHeadText}</h3>
                
                <p>We're going to need to verify your information offline to make sure nobody else has access to your application or personal details.<br/><br/>
                   Please contact us directly as you're able to, so we can help you with the rest of the process - 
                    <br/><a href={'mailto:' + this.props.info_email}>{this.props.info_email}</a>
                    <br/>{this.props.contact_phone}
                    <br/>
                    <a href={'https://' + this.props.domain} target="_top">Home</a>
                </p>
                <hr/>
                <span id="StatusBar" className="StatusBar">
                    {this.state.showSpinner&&<CircularProgress size={30} />}&nbsp;&nbsp;
                    {this.state.status}
                </span>
                <span className='warningMessage'>{this.state.warning}</span>
                <br/>
            </div>
        );
    }

    sendLogRequest = () => {
        // console.log('sending duplicate email creation attempt log...');
        GServ.logIDAttempt(this.props.gwt, this.props.id_obj).then(reply => {
            // console.log('Duplicate email log reply from sever: ', reply);
        });
        //under construction...
        //put a flag / block on the old_account with id number - next time then jump straight to this page...
    }
    
}
